// Keep the startup error UI independent of React and the application chunks.
export async function startApp(load, root = document.getElementById('root'), reload = () => window.location.reload()) {
  try {
    await load();
  } catch (error) {
    console.error('[startup] Application could not load', error);
    const panel = document.createElement('main');
    panel.style.cssText = 'max-width:32rem;margin:15vh auto;padding:2rem;font-family:system-ui;color:#18202b;background:#fff;border-radius:12px';
    panel.setAttribute('role', 'alert');
    const heading = document.createElement('h1');
    heading.textContent = 'ScopeMatrix could not load';
    const message = document.createElement('p');
    message.textContent = 'Check your connection, then reload to try again.';
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Reload ScopeMatrix';
    button.addEventListener('click', reload);
    panel.append(heading, message, button);
    root?.replaceChildren(panel);
  }
}
